<div class="uni-top-bar-menu">
  <uni-icon
    class="uni-top-bar-menu__icon"
    [name]="isProfileNavOpen ? 'chevron-up' : 'chevron-down'"
    [isInherit]="true"
  ></uni-icon>
</div>

<uni-uni-top-bar-troubleshoot-confirm></uni-uni-top-bar-troubleshoot-confirm>
